import React from "react";

export default function ExpoExplanation() {
    return (
        <div className="what-is-ee">
            {/* APARTADO CON RESGISTRO ACTIVO
            
            <div className="ee-logo">
                <img
                    src="assets/images/updates/expo-logo-circle 2.png"
                    alt="Foro Emprendedores"
                />
            </div>
            <div className="ee-explanation">
                <h3>¿Qué es Foro Emprendedores?</h3>
                <p>
                    Es un foro donde los emprendedores tienen la oportunidad de recibir asesoria 
                    para fortalecer sus proyectos y empresas, compartir sus ideas con una audiencia
                    mas amplia, recibir retroalimentación, establecer contactos con posibles socios
                    comerciales e inversores, y aprender de otros emprendedores y expertos en la industria.

                    Buscamos que el foro del emprendedor en esta edición, así como en las pasadas
                    ediciones sea un excelente fuente de inspiración, aprendizaje y oportunidades de
                    networking, donde puedan descubrirnuevas empresas y productos innovadores, obtener
                    información sobre las últimas tendencias en el mundo del emprendimiento y encontrar
                    recursos útiles para apoyar sus propios proyectos emprensariales.

                    El foro del emprendedore una plataforma importante donde buscamos fomentar la 
                    colaboración, la innovación y el crecimiento dentro del ecosistema emprendedor, brindando
                    oportunidades tanto para los emprendedores como para aquellos interesados en el mundo
                    empresarial.
                </p>
            </div> */}
            {/* APARTADO CON REGISTRO DESACTIVADO */}
            <div style={{
                width: '100%',
                margin: '0 auto',
                
            }}>
                <h5 className="text-center" style={{ color: '#D85C76',fontSize:'50px' }}>
                    ¿Qué es Foro Emprendedores?
                </h5>
                <p style={{textAlign:'justify', fontSize:'30px'}}>
                    Es un foro donde los emprendedores tienen la oportunidad de recibir asesoria 
                    para fortalecer sus proyectos y empresas, compartir sus ideas con una audiencia
                    mas amplia, recibir retroalimentación, establecer contactos con posibles socios
                    comerciales e inversores, y aprender de otros emprendedores y expertos en la industria.

                    Buscamos que el foro del emprendedor en esta edición, así como en las pasadas
                    ediciones sea un excelente fuente de inspiración, aprendizaje y oportunidades de
                    networking, donde puedan descubrirnuevas empresas y productos innovadores, obtener
                    información sobre las últimas tendencias en el mundo del emprendimiento y encontrar
                    recursos útiles para apoyar sus propios proyectos emprensariales.

                    El foro del emprendedore una plataforma importante donde buscamos fomentar la 
                    colaboración, la innovación y el crecimiento dentro del ecosistema emprendedor, brindando
                    oportunidades tanto para los emprendedores como para aquellos interesados en el mundo
                    empresarial.
                </p>
            </div>
        </div>
    );
}
